import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import PreferencesCollection from './PreferencesCollection';

interface PreferencesSetupProps {
  onComplete: () => void;
  onSkip: () => void;
}

const PreferencesSetup: React.FC<PreferencesSetupProps> = ({ onComplete, onSkip }) => {
  const { updatePreferences, refreshUserProfile } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handlePreferencesComplete = async (preferences: any) => {
    setIsLoading(true);
    try {
      // First update the preferences
      await updatePreferences(preferences);
      
      // Then mark preferences as completed
      const response = await fetch('/api/preferences/complete_setup/', {
        method: 'POST',
        headers: {
          'Authorization': `Token ${localStorage.getItem('authToken')}`,
        },
      });
      
      if (response.ok) {
        const data = await response.json();
        
        // Refresh user profile to get updated preferences
        await refreshUserProfile();
      } else {
        console.error('Failed to complete preferences setup');
      }
      
      onComplete();
    } catch (error) {
      console.error('Error saving preferences:', error);
      // Still complete the setup even if preferences fail
      onComplete();
    } finally {
      setIsLoading(false);
    }
  };

  const handleSkip = () => {
    onSkip();
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-violet-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto mb-4"></div>
          <p className="text-white text-lg">Saving your preferences...</p>
        </div>
      </div>
    );
  }

  return (
    <PreferencesCollection
      onComplete={handlePreferencesComplete}
      onSkip={handleSkip}
    />
  );
};

export default PreferencesSetup;
